import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IAperturaCajaReq,
  ICerrarCajaRes,
  ICierreCajaReq,
  IObtenerMontoRes,
  IReporteCajaFiltroReq,
  IResumenConReporteCajaRes,
} from '@core/interfaces/request-response/caja.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class CajaTurnoApiService extends BaseHttpService {
  checkApertura() {
    return this.withLoader(
      this.httpClient.get<boolean>(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/check-apertura`,
      ),
    );
  }
  aperturar(req: IAperturaCajaReq) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/aperturar`,
        req,
      ),
    );
  }
  cerrar(req: ICierreCajaReq) {
    return this.withLoader(
      this.httpClient.post<boolean>(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/cerrar`,
        req,
      ),
    );
  }
  montoCaja() {
    return this.httpClient.get<IObtenerMontoRes>(
      `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/monto-caja`,
    );
  }
  cuadrarCaja() {
    return this.withLoader(
      this.httpClient.get<ICerrarCajaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/cuadrar-caja`,
      ),
    );
  }
  paginarReporte(rq: IReporteCajaFiltroReq, pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.post<IResumenConReporteCajaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/paginar-reporte`,
        rq,
        { params },
      ),
    );
  }

  exportarReporteExcel(rq: IReporteCajaFiltroReq) {
    return this.withLoader(
      this.httpClient.post(
        `${environment.apiUrl}${environment.apiPreFix}/caja-turno/v2/exportar-reporte-excel`,
        rq,
        {
          observe: 'response',
          responseType: 'blob',
        },
      ),
    );
  }
}
